"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarginsApi = exports.SizeApi = void 0;
var SizeApi = (function () {
    function SizeApi(width, height) {
        this.width = Math.max(0, width);
        this.height = Math.max(0, height);
    }
    return SizeApi;
}());
exports.SizeApi = SizeApi;
var MarginsApi = (function () {
    function MarginsApi(left, right, top, bottom) {
        this.left = Math.max(0, left);
        this.right = Math.max(0, right);
        this.top = Math.max(0, top);
        this.bottom = Math.max(0, bottom);
    }
    return MarginsApi;
}());
exports.MarginsApi = MarginsApi;
